
import { CheckCircle, XCircle, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface RequestStatusBadgeProps {
  status: 'approved' | 'rejected' | 'pending';
}

const RequestStatusBadge = ({ status }: RequestStatusBadgeProps) => {
  if (status === 'approved') {
    return (
      <Badge className="bg-green-100 text-green-700 hover:bg-green-100">
        <CheckCircle className="w-3 h-3 mr-1" />
        Approved
      </Badge>
    );
  }
  
  if (status === 'pending') {
    return (
      <Badge className="bg-yellow-100 text-yellow-700 hover:bg-yellow-100">
        <Clock className="w-3 h-3 mr-1" />
        Pending
      </Badge>
    );
  }
  
  return (
    <Badge className="bg-red-100 text-red-700 hover:bg-red-100">
      <XCircle className="w-3 h-3 mr-1" />
      Rejected
    </Badge>
  );
};

export default RequestStatusBadge;
